import React, { useEffect } from 'react'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import { LOGOUT, FETCH_SESSION } from '../../_common/redux/auth/actions'

/**
 * InvoiceWrapper HOC that checks if the user needs to pay for services
 * and displays a message with payment button if needed.
 * If conditions are not met, it renders the component passed as the WrappedComponent prop.
 */
const InvoiceWrapper = ({ children, user, isMcDomain, LOGOUT, FETCH_SESSION, ...props }) => {
  // Check if there is an authenticated user and they're seeing the mana page with isMcDomain
  const isAuthenticated = !!user
  const showInvoiceMessage = isAuthenticated && isMcDomain

  // Check if the pay button should be active
  const hasServicesInvoice = _get(user, 'hasServicesInvoice', false)
  const isUpToDate = _get(user, 'invoiceStatus.upToDate', true)
  const shouldShowPayButton = showInvoiceMessage && hasServicesInvoice && !isUpToDate

  // Set up interval to fetch updated user profile every second
  useEffect(() => {
    // Only set up the interval if the pay button is active
    if (shouldShowPayButton) {
      const intervalId = setInterval(() => {
        FETCH_SESSION({ hideError: true })
      }, 2000)

      // Clean up interval on component unmount or when pay button is no longer active
      return () => clearInterval(intervalId)
    }
  }, [shouldShowPayButton, FETCH_SESSION])

  // If all conditions are met, show the payment button
  if (shouldShowPayButton) {
    const paymentLink = _get(user, 'invoiceStatus.paymentLink', '#')

    return (
      <div
        className="invoice-message-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <div className="invoice-message" style={{ marginBottom: '30px' }}>
          <h2 style={{ marginBottom: '15px' }}>Access Restricted</h2>
          <p style={{ marginBottom: '20px' }}>
            Your free trial period is over. You must upgrade to a paid subscription plan to restore access to the platform.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.open(paymentLink, '_blank')}
            style={{ padding: '10px 20px', fontSize: '16px' }}
          >
            Pay Now
          </button>
        </div>
        <div className="logout-container">
          <button
            className="btn btn-secondary"
            onClick={() => LOGOUT()}
            style={{
              padding: '8px 15px',
              backgroundColor: '#6c757d',
              color: '#ffffff',
              border: '1px solid #6c757d',
              fontWeight: 'bold',
              textShadow: 'none',
            }}
          >
            Log Out
          </button>
        </div>
      </div>
    )
  }

  // If conditions are not met render children
  return children
}

const mapStateToProps = state => ({
  user: state.auth.user,
  isMcDomain: _get(state, 'shared.isMcDomain', false),
})

const mapDispatchToProps = {
  LOGOUT,
  FETCH_SESSION,
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceWrapper)
